
import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';

export default function AddListingPage() {
	const navigate = useNavigate();
	const [form, setForm] = useState({
		name: "",
		description: "",
		category: "",
		address: "",
		phone: "",
		email: "",
		website: "",
		image: null,
	});

	const [errors, setErrors] = useState({});
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState("");

	const handleChange = (e) => {
		const { name, value, files } = e.target;
		if (files) {
			const file = files[0];
			setForm((s) => ({ ...s, [name]: file }));
			setSuccess("");
		} else {
			setForm((s) => ({ ...s, [name]: value }));
		}
	};

	const validate = () => {
		const err = {};
		if (!form.name.trim()) err.name = "Name is required";
		if (!form.description.trim()) err.description = "Description is required";
		if (form.email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email)) err.email = "Invalid email";
		if (form.website && !/^https?:\/\//.test(form.website)) err.website = "Website should start with http:// or https://";
		setErrors(err);
		return Object.keys(err).length === 0;
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!validate()) return;
		const formData = new FormData();
		Object.keys(form).forEach((key) => {
			if (form[key] !== null && form[key] !== "") formData.append(key, form[key]);
		});

		setLoading(true);
		setSuccess("");
		try {
			// Replace URL with real endpoint
			const res = await fetch("/api/listings", { method: "POST", body: formData });
			if (!res.ok) throw new Error(`Status ${res.status}`);
			setSuccess("Listing submitted successfully.");
			setForm({ name: "", description: "", category: "", address: "", phone: "", email: "", website: "", image: null });
			setErrors({});
		} catch (err) {
			console.error(err);
			setErrors((s) => ({ ...s, submit: "Submission failed" }));
		} finally {
			setLoading(false);
		}
	};

	return (
		<div style={{ maxWidth: 800, margin: "24px auto", padding: 16 }}>
			<h2>Add Listing</h2>
			<form onSubmit={handleSubmit} encType="multipart/form-data">
				<div style={{ marginBottom: 12 }}>
					<label>Name*</label>
					<br />
					<input name="name" value={form.name} onChange={handleChange} style={{ width: "100%" }} />
					{errors.name && <div style={{ color: "red" }}>{errors.name}</div>}
				</div>

				<div style={{ marginBottom: 12 }}>
					<label>Description*</label>
					<br />
					<textarea name="description" value={form.description} onChange={handleChange} rows={4} style={{ width: "100%" }} />
					{errors.description && <div style={{ color: "red" }}>{errors.description}</div>}
				</div>

				<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
					<div>
						<label>Category</label>
						<br />
						<select name="category" value={form.category} onChange={handleChange} style={{ width: "100%" }}>
							<option value="">Select category</option>
							<option value="food">Food & Drink</option>
							<option value="shopping">Shopping</option>
							<option value="services">Services</option>
							<option value="health">Health</option>
						</select>
					</div>
					<div>
						<label>Phone</label>
						<br />
						<input name="phone" value={form.phone} onChange={handleChange} style={{ width: "100%" }} />
					</div>
				</div>

				<div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginTop: 12 }}>
					<div>
						<label>Email</label>
						<br />
						<input name="email" value={form.email} onChange={handleChange} style={{ width: "100%" }} />
						{errors.email && <div style={{ color: "red" }}>{errors.email}</div>}
					</div>
					<div>
						<label>Website</label>
						<br />
						<input name="website" value={form.website} onChange={handleChange} style={{ width: "100%" }} />
						{errors.website && <div style={{ color: "red" }}>{errors.website}</div>}
					</div>
				</div>

				<div style={{ marginTop: 12 }}>
					<label>Address</label>
					<br />
					<input name="address" value={form.address} onChange={handleChange} style={{ width: "100%" }} />
				</div>

				<div style={{ marginTop: 12 }}>
					<label>Image</label>
					<br />
					<input type="file" name="image" accept="image/*" onChange={handleChange} />
					{form.image && (
						<div style={{ marginTop: 8 }}>
							<div>{form.image.name}</div>
							<div style={{ marginTop: 8 }}>
								<img src={URL.createObjectURL(form.image)} alt="preview" style={{ maxWidth: 200, maxHeight: 200 }} />
							</div>
						</div>
					)}
				</div>
				{errors.submit && <div style={{ color: "red", marginTop: 12 }}>{errors.submit}</div>}

				<div style={{ marginTop: 16 }}>
					<button type="submit" disabled={loading}>{loading ? "Submitting..." : "Submit"}</button>
					{success && <div style={{ color: "green", marginTop: 8 }}>{success}</div>}
				</div>
			</form>
		</div>
	);
}
